var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNew = function SvgNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 8,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#D80C18",
    clipPath: "url(#new_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.575 7.535h1.416V.465H4.336V4.61h-.064L1.44.465H0v7.07h1.66v-4.15h.054zM7.07.465h4.898v1.357H8.73v1.5h2.984v1.352H8.73v1.504h3.238v1.357H7.07zM12.656.465h1.831l1.09 4.682h.063L16.865.465h1.519l1.23 4.697h.059L20.767.465h1.83l-2.045 7.07h-1.616L17.65 3.18h-.048l-1.29 4.355h-1.606z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "new_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h23v8H0z"
  })))));
};
export default SvgNew;